import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar"
import PrimaryButton from "../../../../../common/components/primary_button"
import DynamicIcon from "../../../../../common/components/dynamic_icon";
import { Breadcrumbs, Link, TablePagination, Typography } from "@mui/material";
import RefreshButton from "../../../../../common/components/refresh_button";
import { useMemo } from "react";
import { GenerateQualidadeProvisaoRecursoColumns } from "./columns/qualidade_provisao_recurso";
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid";
import DeleteDialog from "../../../../../common/components/delete_dialog";
import { Header } from "./components/header";
import { useQualidadeProvisaoRecursosListaViewModel } from "../../viewModels/qualidade_provisao_recurso_view_model";
import { ProvisaoRecursoLista } from "../../../domain/models/provisao_recurso_lista";
import { ProvisaoRecursoModal } from "./components/provisao_recurso_modal";
import { ReportViewerModal } from "../../../../../common/components/report_viewer_modal";
import { ReportModal } from "./components/report_modal";
import { ChangeHistoryModal } from "../../../../../common/modals/change_history_modal";

export const ProvisaoRecurso = () => {
  const viewModel = useQualidadeProvisaoRecursosListaViewModel();

  const QualidadeProvisaoRecursoistalColumns = useMemo(() => {
    return GenerateQualidadeProvisaoRecursoColumns({
      onActionEditar: viewModel.handleCadastroProvisaoRecursosOpenState,
      onActionDeletar: viewModel.handleDeleteProvisaoRecursosModalOpenState,
    });
  }, [viewModel.handleCadastroProvisaoRecursosOpenState, viewModel.handleDeleteProvisaoRecursosModalOpenState]);

  return (
    <>
      <PageTopBar>
        <ThreeSlotLayout
          rightSlot={
            <div className="flex flex-row gap-2 items-center">
              <div className="w-[12rem]">
                <PrimaryButton
                  aria-haspopup="true"
                  onClick={() => viewModel.handleReportModalOpenState(true)}
                  buttonColor="yellow">
                  Relatórios
                </PrimaryButton>
              </div>
              <div className="w-[150px] ">
                <PrimaryButton
                  startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                  onClick={() => viewModel.handleCadastroProvisaoRecursosOpenState(null, true)}>
                  Novo
                </PrimaryButton>
              </div>
            </div>
          }
        />
      </PageTopBar>
      <form>
        <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
          <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
            <Link underline="hover" color="inherit">
              Qualidade
            </Link>
            <Typography className="text-primary-green">
              Provisão de Recursos
            </Typography>
          </Breadcrumbs>
          <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
            <div className="flex gap-2 items-center w-full">
              <h1 className="text-3xl font-medium text-black dark:text-white">Provisão de Recursos</h1>
              <RefreshButton onClick={viewModel.handleReload} />
            </div>
          </div>
          <Header
            onClearFilters={viewModel.handleClearFilters}
            handleTipoPesquisa={viewModel.handleTipoPesquisaChange}
            handlePesquisa={viewModel.handlePesquisaChange}
            pesquisa={viewModel.filters.pesquisa}
            tipoPesquisa={viewModel.filters.tipoPesquisa}

          />

          <StyledDataGrid
            tableName="ProvisaoRecursosLista"
            disableColumnMenu={false}
            getRowId={(row: ProvisaoRecursoLista) => row.IdProvisaoRecurso}
            columns={QualidadeProvisaoRecursoistalColumns}
            loading={viewModel.loading}
            rows={viewModel.provisaoRecursosLista}
            rowCount={viewModel.pagination.totalItems}
            sx={{
              '& .status-header': {
                backgroundColor: '#AFDFD5',
                color: '#000'
              }
            }}
            pageSizeOptions={[10]}
            paginationMode="server"
            paginationModel={{
              page: viewModel.pagination.page,
              pageSize: viewModel.pagination.rowsPerPage,
            }} />

          <TablePagination
            component="div"
            count={viewModel.pagination.totalItems}
            page={viewModel.pagination.page - 1}
            onPageChange={(_, p) => viewModel.handlePageChange(p)}
            rowsPerPageOptions={[10, 25, 50, 100]}
            rowsPerPage={viewModel.pagination.rowsPerPage}
            onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))} />
        </div>
      </form>

      {/* Modal */}
      <ChangeHistoryModal
        changeHistoryHandler={viewModel.changeHistory}
      />
      <ReportModal
        saving={viewModel.saving}
        open={viewModel.openReportModal}
        reactHookForm={viewModel.hookForm}
        onSubmit={viewModel.handleSubmitReport}
        onClose={() => viewModel.handleReportModalOpenState(false)}
      />
      <ReportViewerModal
        reportViewerState={viewModel.reportViewerState}
      />
      <ProvisaoRecursoModal
        loading={viewModel.loading}
        onClose={() => viewModel.handleCadastroProvisaoRecursosOpenState(null, false)}
        onSubmit={viewModel.handleProvisaoRecursosSubmit}
        open={viewModel.provisaoRecursosModal}
        saving={viewModel.saving}
        selectedProvisaoRecurso={viewModel.selectedProvisaoRecursos}
        onOpenChangeHistory={(id, tabelaTipo) => viewModel.handleOpenChangeHistory(id, tabelaTipo)} />

      {/* Deletar Registro */}
      <DeleteDialog
        open={viewModel.provisaoRecursosDeleteModal}
        saving={viewModel.saving}
        onClose={() => viewModel.handleDeleteProvisaoRecursosModalOpenState(null, false)}
        title={`Você realmente deseja excluir este item?`}
        onDelete={viewModel.handleDeleteConfirmaProvisaoRecursos} />
    </>
  )
}